import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from 'src/app/services/encryption.service';


@Injectable({
  providedIn: 'root'
})
export class premissionServices  {
  constructor(private router: Router, private _authService:AuthService, private _EncryptionService: EncryptionService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const profile = this._EncryptionService.decryptLocalStorage('profile');
    if (this._authService.isAuthenticated()) {
      if (profile.type === "DRIVER") {
        this.router.navigate(['/sp/my-trips']);
      } else {
        this.router.navigate(['/sp-profile/profile']);
      }
      return false;
    } else {
      return true;
    }
  }
}
export const MainGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(premissionServices).canActivate(next, state);
};

